import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import StateSelector from './components/StateSelector/stateSelector';
import GetFormComplete from './components/RequestConfirmation/requestConfirmation';
import GetVerificationForm from './components/VerificationForm/verificationFormContainer';
import ExperianForm from './components/ExperianForm/Container';
import GetPinForm from './components/CreatePinForm/container';
import RequestSelector from './components/RequestSelector/requestSelector';
import GetMailingAddress from './components/MailingAddress/mailingAddressContainer';
import Header from './components/Header/header';
import StatusForm from './components/StatusForm/statusForm';
import RightToCorrectContainer from './components/RightToCorrect/rightToCorrectContainer';
import MaintenanceComp from './components/MaintenanceComp';
import DeleteInfoPreConfirmation from './components/MailingAddress/deletePreConfirm';
import RequestFlow from './components/StateSelector/RequestFlow';
import Landing from './components/RightToCorrect/Landing';
import CacheBuster from './CacheBuster';
import RightToCorrectPersonnel from './components/RightToCorrect/customerTypes/rightToCorrectPersonnel';
import RightToCorrectVCI from './components/RightToCorrect/rightToCorrectVCI';
import Callback from './components/SecureKey/CallbackRoute';
import i18n from './i18n';
import './App.css';
import RightToWithdraw from './components/withdraw/RightToWithdraw';
import CallbackForCheck from './components/SecureKey/CallbackForCheck';

class App extends Component {

  // To access QCPP

  constructor(props) {
    super(props);
    const pathname = window.location.pathname?.toLowerCase();
    const isCanada = pathname === "/canada" || pathname === "/callback" || (window.location.pathname) === "/cmsCallback";
    const origin = window.location.origin?.toLowerCase();
    if (origin?.includes('vwfinance.ca') || origin?.includes('audifinance.ca') || (origin?.includes('localhost') && isCanada)) {
      this.props.updateCountry({
        country: "Canada",
      });
      i18n.changeLanguage("fr-CA");
      this.props.updateLanguage({
        language: "FRA",
      });
    };
  };

  render(){
    window.localStorage.setItem('brand-theme','privacy');
    const jsurl = `./@vwfs-bronson/bronson-vwfs-corporate/dist/js/bronson.min.js`;
    const cssurl = `./@vwfs-bronson/bronson-vwfs-corporate/dist/css/style.min.css`;
    if (window.location.pathname === "/verificationForm/tier2") {
      window.location.replace("/verificationForm");
    }
    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }

    return (
      <div className='container'>
        <Helmet>
          <script type='text/javascript' src={jsurl} />
          <link rel='stylesheet' href={cssurl} />
        </Helmet>
        <div id='privacy'>
            <div className='o-layout u-m-none'>
              <div className='u-1/1'>
                <Header />
              </div>
            </div>
            <div id='router-content-wrapper'>
              <div id='router-content'>
                <Router>
                  <Switch>
                    <Route exact path='/' component={StateSelector} />
                    <Route exact path='/donotsell' component={StateSelector} />
                    <Route path='/requestqualifier' component={RequestFlow} />
                    <Route path='/requestselector' component={RequestSelector} />
                    <Route path='/mailingAddress' component={GetMailingAddress} />
                    <Route path='/deletePreConfirm' component={DeleteInfoPreConfirmation} />
                    <Route path='/formComplete' component={GetFormComplete} />
                    <Route path='/experianForm' component={ExperianForm} />
                    <Route path='/pinForm' component={GetPinForm} />
                    <Route path='/verificationForm' component={GetVerificationForm} />
                    <Route path ='/status' component={StatusForm} />
                    <Route path ='/dataCorrectionVCI' component={RightToCorrectVCI} />
                    <Route path ='/dataCorrectionForm' component={RightToCorrectContainer} />
                    <Route path ='/withdraw' component={RightToWithdraw} />
                    <Route path ='/dataCorrectionUserType' component={Landing} />
                    <Route path ='/RightToCorrectPersonnel' component={RightToCorrectPersonnel} />
                    <Route path ='/maintenance' component={MaintenanceComp}/>
                    <Route path ='/callback' component={Callback}/>
                    <Route path ='/cmsCallback' component={CallbackForCheck}/>
                    <Route path ='*' component={StateSelector} />
                  </Switch>
                </Router>
              </div>
            </div>
        </div>
      </div>
      )
    }}
    </CacheBuster>
  );
  }
}

App.propTypes = {
  updateCountry: PropTypes.func,
  updateLanguage: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
  };
};

const mapDispatchToProps = dispatch => ({
  updateCountry: values => dispatch({ type: "UPDATE_COUNTRY", payload: values }),
  updateLanguage: values => dispatch({ type: "UPDATE_LANGUAGE", payload: values }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
